// extracted by mini-css-extract-plugin
export default {"infoBox":"styles_infoBox__9hKlH","offerTimer":"styles_offerTimer__cyVhz","centeredTimer":"styles_centeredTimer__swDFK","timerIcon":"styles_timerIcon__sWPic"};